<!-- 联系我们 -->
<template>
  <div class="frame">
    <Breadcrumb :breadcrumbs="breadcrumbs" />
    <div class="wrap">
      <div class="box">
        <img class="logo" src="../assets/logo.png" />
        <div class="title-box">
          <div class="title">四川省建协人才服务中心友情提示</div>
        </div>
        <div class="content">
          <div class="item bold">
            1、本中心依托合作培训机构为责任主体，统一签发岗位培训合格证书（包括合格证和施工作业操作证），是工程行业相关领域人员岗位基本知识与基础能力凭证；适用工程机械设备施工岗位的基础能力上机操作需要。施工作业操作证属岗位能力层面操作证，应与培训合格证联合使用不可分割。
          </div>
          <div class="item">
            2、对于特种设备及岗位除岗位能力达标外还需获得从业准入资格证，如质监总局特种设备目录“桥式、门式、塔式、流动等类别的起重机械、施工电梯、工厂叉车岗位（请参阅：特种设备目录）和“住建部”建筑施工现场特种作业工种\特殊工种”人员，法规有行政许可与安全从业准入的资质资格的特殊规定，要求操作者参加政府安全培训，获政府部门“特种人员证”或“特种作业证书”，方可进入特种行业或场合从业。
          </div>
          <div class="item">
            3、对于特种设备及岗位，本中心证书不能替代特种作业资格证、特种设备人员证等行政许可从业准入类的资质资格证书。
          </div>
          <div class="item">
            本中心组织的职业技能、工程机械岗位培训基于考训双方市场化自愿规则，仅限“岗位基础知识能力层面”。中心签发的培训合格证书不是特种证件，不属于从业准入类证书，不能替代政府应急、住建、质监部门的特种作业资格操作证件、特种设备作业人员证等使用。
          </div>
          <div class="phones">
            <div class="phone">中心联系电话（监督与举报）：19181909780</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../components/breadCrumb.vue";
export default {
  components: { Breadcrumb },
  data() {
    return {
      breadcrumbs: [],
    };
  },
  methods: {},
  created() {
    this.breadcrumbs = [
      { path: "/", name: "首页" },
      { name: this.$route.name },
    ];
  },
};
</script>

<style lang="scss" scoped>
.frame {
  background-color: #f9f9f9;

  &::after {
    content: "";
    display: table;
  }
}
.wrap {
  width: 1200px;
  margin: 0 auto 20px;
  background-color: #fff;
  box-shadow: 0 0 5px #eee;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 5px;

  .title-box {
    width: fit-content;
    margin: 40px auto;
    text-align: center;

    .title {
      padding: 5px 0;
      font-size: 28px;
      font-weight: bold;
      position: relative;

      &::before {
        content: "";
        width: 40px;
        height: 2px;
        background-color: $theme;
        position: absolute;
        right: -60px;
        top: 50%;
        transform: translateY(-50%);
      }
      &::after {
        content: "";
        width: 40px;
        height: 2px;
        background-color: $theme;
        position: absolute;
        left: -60px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .logo {
    width: 400px;
  }
  .box {
    padding-bottom: 40px;

    .content {
      width: 800px;
      margin: 0 auto;

      .item {
        padding: 20px 0;
        text-indent: 2em;
        line-height: 2;
        border-bottom: 1px solid #ddd;
      }
      .bold {
        font-weight: bold;
      }
      .phones {
        text-align: right;
        font-size: 15px;
        padding: 30px 0;

        .phone + .phone {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
